import React from 'react';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

import { ModalWrapper, CloseButton, ModalDescription, SignInButton, Highlight } from './styles';

export function LimitAttemptsModal({ handleClose }) {

  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
        disableBackdropClick 
      >
        <ModalWrapper>
          <CloseButton onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
          <ModalDescription id="success-modal-description">
            Você excedeu o limite de tentativas. Aguarde 30 minutos para tentar novamente ou contate o SAP Central para mais informações: <br />
            <Highlight>4003-0267</Highlight> ou <Highlight>sap@ultragaz.com.br</Highlight> 
          </ModalDescription>
          <SignInButton type="button" onClick={() => {
             handleClose()
          }}>
            <span> Voltar para o início</span>
          </SignInButton>
        </ModalWrapper>
      </Modal>

  );
}
